import { memo } from 'react';

import { twMerge } from '@air/utils-tailwind';

const CREDIT_USAGE_METER_CENTER_PX = 12;
const CREDIT_USAGE_METER_RADIUS_PX = 9;
const CREDIT_USAGE_METER_STROKE_WIDTH = 1.75;
const CREDIT_USAGE_METER_TRACK_OPACITY = 0.28;
const FULL_CREDIT_USAGE_PERCENT = 100;

export type CreditUsageMeterRingProps = {
  className?: string;
  percentUsed: number;
};

export const CreditUsageMeterRing = memo(({ className, percentUsed }: CreditUsageMeterRingProps) => {
  const circumference = 2 * Math.PI * CREDIT_USAGE_METER_RADIUS_PX;
  const filledLength = (percentUsed / FULL_CREDIT_USAGE_PERCENT) * circumference;

  return (
    <svg
      aria-hidden="true"
      className={twMerge('size-3.5 shrink-0', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={CREDIT_USAGE_METER_CENTER_PX}
        cy={CREDIT_USAGE_METER_CENTER_PX}
        r={CREDIT_USAGE_METER_RADIUS_PX}
        stroke="currentColor"
        strokeOpacity={CREDIT_USAGE_METER_TRACK_OPACITY}
        strokeWidth={CREDIT_USAGE_METER_STROKE_WIDTH}
      />
      <circle
        cx={CREDIT_USAGE_METER_CENTER_PX}
        cy={CREDIT_USAGE_METER_CENTER_PX}
        r={CREDIT_USAGE_METER_RADIUS_PX}
        stroke="currentColor"
        strokeDasharray={`${filledLength} ${circumference}`}
        strokeLinecap="round"
        strokeWidth={CREDIT_USAGE_METER_STROKE_WIDTH}
        transform={`rotate(-90 ${CREDIT_USAGE_METER_CENTER_PX} ${CREDIT_USAGE_METER_CENTER_PX})`}
      />
    </svg>
  );
});

CreditUsageMeterRing.displayName = 'CreditUsageMeterRing';
